
var $ = jQuery.noConflict();
$(document).ready(function() {
  $(window).on("load resize",function(e){
    resize_image();
  });

  resize_image();

  $('.button.button_step_start').on('click', function(e){
    e.preventDefault();
    goNext($(this), 'step_1');
  });

  $('.step_1 .back a').on('click', function(e){
    e.preventDefault();

    $(this).closest(".solar_saving_calculator--content").removeClass('active');
    $('.solar_saving_calculator--content.step_start').addClass('active');
    // $('html, body').animate({ scrollTop: 0 }, 'slow');

    scrollTop();
  });

  $('.step_1 .button_step_next').on('click', function(e){
    e.preventDefault();
    var home_phase = $('input[name="step1"]:checked').val();
    if(home_phase != null){
      goNext($(this), 'step_2');
    }    
  });

  $('.step_2 .button_step_next').on('click', function(e){
    e.preventDefault();
    var electricity_billed = $('input[name="step2"]:checked').val();
    if(electricity_billed != null){
      goNext($(this), 'step_3');
    }    
  });

  $('.step_3 .button_step_next').on('click', function(e){
    e.preventDefault();
    var bill_amount = $('input[name="bill_amount"]').val();
    if(bill_amount != '' && bill_amount != '0'){
      goNext($(this), 'step_4');
    }    
  });

  $('.step_4 .button_step_next').on('click', function(e){
    e.preventDefault();
    var cost_electricity = $('input[name="electricity_cost"]').val();
    if(cost_electricity != '' && cost_electricity != '0'){
      calculate();
      goNext($(this), 'step_5');
    }    
  });

  $('.step_5 .button_step_next').on('click', function(e){
    e.preventDefault();
    goNext($(this), 'step_6');   
  });

  $('.step_6 .button_step_next').on('click', function(e){
    e.preventDefault();
    var electricity_used = $('input[name="daytime_usage"]').val();
    if(electricity_used != '' && electricity_used != '0'){
      goNext($(this), 'step_7');
    }    
  });

  $('.step_7 .button_step_next').on('click', function(e){
    e.preventDefault();
    var export_rate = $('input[name="export_rate"]').val();
    if(export_rate != '' && export_rate != '0'){
      goNext($(this), 'step_8');
    }    
  });

  $('.step_8 .button_step_next').on('click', function(e){
    e.preventDefault();
    var system_size = $('input[name="step8"]:checked').val();
    if(system_size != null){
      goNext($(this), 'computation');
    }    
  });

  var existCondition = setInterval(function() {
    if ( $('.hbspt-form .submitted-message').length > 0 ) {
      
      calculate();

      $(".solar_saving_calculator--content.computation").removeClass('active');
      $('.solar_saving_calculator--content.step_final').addClass('active');
      // $('html, body').animate({ scrollTop: 0 }, 'slow');
      scrollTop();

      clearInterval(existCondition);
    }
  }, 1);

  $("input[type=radio]").change(function(){
    $(this).closest('.solar_saving_calculator--left').find('.content--bottom .button_step_next').removeClass('disabled');

    $(this).closest('.solar_saving_calculator--left').find('.steps_fields .fieldset.radio').removeClass('active');

    $(this).parent().parent().addClass('active');

    // calculate();
  });

  $("input[type=text]").bind("input", function() { 
    var $this = $(this);
    $this.val($this.val().replace(/[^\d.]/g, '')); 

    if($(this).val() == ''){
      $(this).closest('.solar_saving_calculator--left').find('.content--bottom .button_step_next').addClass('disabled');
    } else {
      $(this).closest('.solar_saving_calculator--left').find('.content--bottom .button_step_next').removeClass('disabled');
    }

    // calculate();
  });

  $(".steps_fields .fieldset input").keyup(function() {
    var $this = $(this);
    $this.val($this.val().replace(/[^\d.]/g, ''));        
  });

  $('.button_step_previous').on('click', function(e){
    e.preventDefault();

    var prev = $(this).attr('data-prev');

    goPrev($(this), prev);
  });

  $('.computation .back a').on('click', function(e){
    e.preventDefault();

    $(".solar_saving_calculator--content.computation").removeClass('active');
    $('.solar_saving_calculator--content.step_8').addClass('active');
    // $('html, body').animate({ scrollTop: 0 }, 'slow');
    scrollTop();
  });

    
});

function goNext(current, show){
  current.closest(".solar_saving_calculator--content").removeClass('active');
  $('.solar_saving_calculator--content.'+show).addClass('active');
  // $('html, body').animate({ scrollTop: 0 }, 'slow');
  scrollTop();
}

function goPrev(current, show){
  current.closest(".solar_saving_calculator--content").removeClass('active');
  $('.solar_saving_calculator--content.'+show).addClass('active');
  // $('html, body').animate({ scrollTop: 0 }, 'slow');
  scrollTop();
}

function calculate(){
  var home_phase = $('input[name="step1"]:checked').val();
  var electricity_billed = $('input[name="step2"]:checked').val();
  var bill_amount = $('input[name="bill_amount"]').val();
  var cost_electricity = $('input[name="electricity_cost"]').val();
  var average_daily_use = $('input[name="average_daily"]').val();
  var electricity_used = $('input[name="daytime_usage"]').val();
  var export_rate = $('input[name="export_rate"]').val();
  var system_size = $('input[name="step8"]:checked').val();
  
  
  if( home_phase != null && electricity_billed != null && bill_amount != "" ){
    if(bill_amount > 0){
    
    // electricity cost
      if(electricity_billed == 'Quarterly'){
        var annual_electricity_cost = bill_amount * 4
      } else if(electricity_billed == 'Monthly'){
        var annual_electricity_cost = bill_amount * 12
      }

    // electricity cost after 20 years
      if(electricity_billed == 'Quarterly'){
        var rate = 0.005;
        var nper = 80; 
      } else if(electricity_billed == 'Monthly'){
        var rate = 0.001666666667;
        var nper = 240;
      }

      var pmt = -Math.abs(bill_amount)
      var pv = bill_amount;
      var type = 1;

      futureValue = calculateFV(rate, nper, pmt, pv, type);

    // average daily use estimate
      var average_daily_estimate = 0;
      if(cost_electricity > 0){
        if(electricity_billed == 'Quarterly'){
          var average_daily_estimate = ((bill_amount - (90 * 1.2)) / 90 / (cost_electricity / 100)).toFixed(2);
        } else if(electricity_billed == 'Monthly'){
          var average_daily_estimate = ((bill_amount - (30 * 1.2)) / 30 / (cost_electricity / 100)).toFixed(2);
        }
      }
      $('input[name="average_daily_estimate"]').val(average_daily_estimate);  

    // annual production
      var annual_production = 0;
      if(system_size > 0){
        var annual_production =  Math.floor(system_size * 4.2 * 365)

        $('.result_annual_consumption span span').html(~~annual_production);  
      }

    // consumed electricity
      if(average_daily_use == "" && average_daily_use <= 0 ){

        if(electricity_used > 0 ){
          if( (average_daily_estimate * electricity_used / 100 * 365) > annual_production ) {
            var consumed_electricity =  Math.floor(annual_production);
          } else {
            var consumed_electricity =  Math.floor(average_daily_estimate * electricity_used / 100 * 365);
          }

          $('.result_consumed_electricity span span').html(~~consumed_electricity);  

        }

      } else {

        if(electricity_used > 0 ){
          if( (average_daily_use * electricity_used / 100 * 365) > annual_production ) {
            var consumed_electricity =  Math.floor(annual_production);
          } else {
            var consumed_electricity =  Math.floor(average_daily_use * electricity_used / 100 * 365);
          }

          $('.result_consumed_electricity span span').html(~~consumed_electricity);
        }
      }
    
    // exported electricity
      var exported_electricity = 0;
      if( (annual_production - consumed_electricity) > (4.2 * 5 * 365) ){
        var exported_electricity = Math.floor(4.2 * 5 * 365);
      } else {
        var exported_electricity = Math.floor(annual_production - consumed_electricity);
      }
      $('.result_exported_electricity span span').html(~~exported_electricity);
    
    // unused portion
      var unused_portion = Math.floor((annual_production - (consumed_electricity + exported_electricity))); 
      $('.result_unused_wattage span span').html(~~unused_portion);

    // battery capacity during_winter
      var battery_capacity_during_winter = Math.ceil(exported_electricity / 365 * 0.5);
      $('.result_battery_capacity span span').html(~~battery_capacity_during_winter);

    //average_annual_savings
      var average_annual_savings = (consumed_electricity) * cost_electricity / 100 + exported_electricity * ((100 - electricity_used) / 100) * export_rate / 100;
      if(isNaN(average_annual_savings)){
        $('.result_annual_savings span span').html('0');
      } else {
        $('.result_annual_savings span span').html((formatCurrency(average_annual_savings.toFixed(2))));
      }

    //new_avarage_bill_amount
      if(electricity_billed == 'Quarterly'){
        var new_avarage_bill_amount = (annual_electricity_cost - average_annual_savings) / 4;
      } else if(electricity_billed == 'Monthly'){
        var new_avarage_bill_amount =  (annual_electricity_cost - average_annual_savings) / 12;
      }

      if(isNaN(average_annual_savings)){
        $('.result_new_average_bill_anount span span').html('0'); 
      } else {
        $('.result_new_average_bill_anount span span').html((formatCurrency(new_avarage_bill_amount.toFixed(2)))); 
      }

    //save electricity bill yearly
      if(isNaN(average_annual_savings)){
        $('.saving_note').hide();
      } else {
        $('.saving_note').show();
        var precent_savings = (average_annual_savings / annual_electricity_cost) * 100;
        $('.solar_saving_calculator--content.step_final .content--top .savings').html(Math.floor(precent_savings)+'%');
      }

    }
  }
}

function formatCurrency(amount) {
  var n= amount.toString().split(".");
  n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return n.join(".");
}

function calculateFV(rate, nper, pmt, pv = 0, type = 0) {
  let fv;
  if (rate === 0) {
      fv = pv + pmt * nper;
  } else {
      fv = pv * Math.pow(1 + rate, nper) + pmt * ((Math.pow(1 + rate, nper) - 1) / rate) * (1 + rate * type);
  }
  return fv;
}

function resize_image(){
  var viewport_height = window.innerHeight;
  var header_height = $('.shopify-section-group-header-group').innerHeight();

  var set_height = '900';

  if( viewport_height - header_height < 900){
    var set_height = viewport_height - header_height - 40;
  }

  $('.solar_saving_calculator--content').css('min-height', set_height+'px');
}

function scrollTop(){
  // $('html,body').animate({
  //   scrollTop: $('.solar_saving_calculator--left').offset().top - 200
  // }, 500);

  $('html, body').animate({ scrollTop: 0 }, 'fast');
}
